import { TypeOfTestTemplateBody } from './TypeOfTestTemplateBody';

export const TEST_ACTIONS = {
    SET_ACTIVE_TEST_TYPE: 'SET_ACTIVE_TEST_TYPE',
}

export type TypeOfTestTemplateAction =
    { type: 'typeOfTestTemplate_SUCCESS'; data: TypeOfTestTemplateBody[] }
    | { type: 'typeOfTestTemplate_FAILED'; data: string }
    | { type: 'SET_ACTIVE_TEST_TYPE', data: any };

export function setActiveTestType(data: any) {
    return (dispatch: Function) => dispatch({ type: TEST_ACTIONS.SET_ACTIVE_TEST_TYPE, data });
}